import git from "isomorphic-git"
import {useEffect, useState, useContext, Dispatch, SetStateAction} from "react"
import {Route, Routes, useParams} from "react-router-dom"
import {BackendContext} from "../../../context/BackendContext"
import {useGitDir} from "../../../hooks/useGitDir"
import {PullRequest} from "../../../models/PullRequest.model"
import {RepoDB} from "../../../models/RepoDB.model"
import styles from "./index.module.scss"
import {ListPR} from "./ListPR"
import {NewPR} from "./NewPR"
import {ShowPR} from "./ShowPR"

interface PullRequestPageProps {
  repoDB?: RepoDB
  repoReplCnt: number
  setRepoReplCnt: Dispatch<SetStateAction<number>>
}

export const PullRequestPage = (props: PullRequestPageProps) => {
  const {repoDB, repoReplCnt, setRepoReplCnt} = props
  const {orbitId, repoId} = useParams()
  const {fs} = useContext(BackendContext)
  const gitDir = useGitDir(orbitId, repoId)
  const [branches, setBranches] = useState<string[]>([])

  useEffect(() => {
    if (!fs || !gitDir) {
      return
    }
    git.listBranches({fs, gitdir: gitDir}).then(
      branches => setBranches(branches)
    )
  }, [fs, gitDir, setBranches])

  if (!repoDB || !orbitId || !repoId || !fs) {
    return null
  }

  const pullRequests: PullRequest[] = Object.keys(repoDB.all)
    .filter(key => key.startsWith("pullRequest_"))
    .map(key => repoDB.get(key as `pullRequest_${string}`))
    .sort((a, b) => a.createAt > b.createAt ? -1 : 1)

  return (
    <div className={styles.Container}>
      <Routes>
        <Route path="/" element={<ListPR pullRequests={pullRequests}/>}/>
        <Route path="/new" element={<NewPR repoDB={repoDB} branches={branches}/>}/>
        <Route path="/:pullRequestId"
               element={<ShowPR repoDB={repoDB} repoReplCnt={repoReplCnt} setRepoReplCnt={setRepoReplCnt}/>}/>
      </Routes>
    </div>
  )
}
